// Saga for Redux Purchase

import { call, put, all, takeEvery } from "redux-saga/effects";
import {
  GET_PURCHASE_LIST,
  GET_SINGLE_PURCHASE,
  CREATE_SINGLE_PURCHASE,
  UPDATE_SINGLE_PURCHASE,
  GET_PURCHASE_STATUS_LIST,
  SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST,
  GET_PURCHASE_ITEM_CATEGORY_LIST,
  SEARCH_PURCHASE_ITEM_BY_JOB_ID,
  CONVERT_PURCHASE_ITEM_TO_BILLABLE,
  UNLINK_PURCHASE_ITEM_BILLABLE,
  MARK_PURCHASE_ITEM_BILLED,
  MARK_PURCHASE_ITEM_IGNORED,
  ADD_NEW_PURCHASE_STATUS,
  DELETE_PURCHASE_STATUS,
  UPDATE_PURCHASE_STATUS,
  ADD_NEW_PURCHASE_ITEM_CATEGORY,
  DELETE_PURCHASE_ITEM_CATEGORY,
  UPDATE_PURCHASE_ITEM_CATEGORY,
  DELETE_SINGLE_PURCHASE,
  SEARCH_PURCHASE_ITEM_LIST,
  UPLOAD_PURCHASE_DRAFT,
  CREATE_FILE_ATTACHMENT,
  SEARCH_PURCHASE_ATTACHMENT,
  DELETE_JOB_ATTACHMENT,
  PREDICT_TRANSACTION_FINANCIAL,
} from "./actionType";

import {
  getPurchaseListSuccess,
  getPurchaseListFailure,
  getSinglePurchaseSuccess,
  getSinglePurchaseFailure,
  createSinglePurchaseSuccess,
  createSinglePurchaseFailure,
  updateSinglePurchaseSuccess,
  updateSinglePurchaseFailure,
  getPurchaseStatusListSuccess,
  getPurchaseStatusListFailure,
  searchSingleSupplierPurchaseListSuccess,
  searchSingleSupplierPurchaseListFailure,
  getPurchaseItemCategoryListSuccess,
  getPurchaseItemCategoryListFailure,
  searchPurchaseItemByJobIdSuccess,
  searchPurchaseItemByJobIdFailure,
  convertPurchaseItemToBillableSuccess,
  convertPurchaseItemToBillableFailure,
  unlinkPurchaseItemBillableSuccess,
  unlinkPurchaseItemBillableFailure,
  markPurchaseItemBilledSuccess,
  markPurchaseItemBilledFailure,
  markPurchaseItemIgnoredSuccess,
  markPurchaseItemIgnoredFailure,
  addNewPurchaseStatusSuccess,
  addNewPurchaseStatusFailure,
  deletePurchaseStatusSuccess,
  deletePurchaseStatusFailure,
  updatePurchaseStatusSuccess,
  updatePurchaseStatusFailure,
  addNewPurchaseItemCategorySuccess,
  addNewPurchaseItemCategoryFailure,
  deletePurchaseItemCategorySuccess,
  deletePurchaseItemCategoryFailure,
  updatePurchaseItemCategorySuccess,
  updatePurchaseItemCategoryFailure,
  deleteSinglePurchaseSuccess,
  deleteSinglePurchaseFailure,
  searchPurchaseItemListSuccess,
  searchPurchaseItemListFailure,
  uploadPurchaseDraftSuccess,
  uploadPurchaseDraftFailure,
  createFileAttachmentSuccess,
  createFileAttachmentFailure,
  searchPurchaseAttachmentSuccess,
  searchPurchaseAttachmentFailure,
  deleteJobAttachmentSuccess,
  deleteJobAttachmentFailure,
  predictTransactionFinancialSuccess,
  predictTransactionFinancialFailure,
} from "./action";

import {
  getPurchaseListApiCall,
  getSinglePurchaseDataApiCall,
  createSinglePurchaseApiCall,
  updateSinglePurchaseApiCall,
  getPurchaseStatusListApiCall,
  searchSingleSupplierPurchaseListApiCall,
  getPurchaseItemCategoryListApiCall,
  searchPurchaseItemByJobIdApiCall,
  convertPurchaseItemToBillableApiCall,
  unlinkPurchaseItemBillableApiCall,
  markPurchaseItemBilledApiCall,
  markPurchaseItemIgnoredApiCall,
  addNewPurchaseStatusApiCall,
  deletePurchaseStatusApiCall,
  updatePurchaseStatusApiCall,
  addNewPurchaseItemCategoryApiCall,
  deletePurchaseItemCategoryApiCall,
  updatePurchaseItemCategoryApiCall,
  deleteSinglePurchaseApiCall,
  searchPurchaseItemListApiCall,
  uploadPurchaseDraftApiCall,
  createFileAttachmentApiCall,
  searchPurchaseAttachmentApiCall,
  deleteJobAttachmentApiCall,
  predictTransactionFinancialApiCall,
} from "../../helpers/fakebackend_helper";

// Get Purchase List Saga

function* getPurchaseListSaga() {
  try {
    const response = yield call(getPurchaseListApiCall);
    yield put(getPurchaseListSuccess(response));
  } catch (error) {
    yield put(getPurchaseListFailure(error));
  }
}

export function* watchGetPurchaseListSaga() {
  yield takeEvery(GET_PURCHASE_LIST, getPurchaseListSaga);
}
// Get Single Purchase Saga

function* getSinglePurchaseSaga(action) {
  try {
    const response = yield call(getSinglePurchaseDataApiCall, action.payload);
    yield put(getSinglePurchaseSuccess(response));
  } catch (error) {
    yield put(getSinglePurchaseFailure(error));
  }
}

export function* watchGetSinglePurchaseSaga() {
  yield takeEvery(GET_SINGLE_PURCHASE, getSinglePurchaseSaga);
}

// Create Single Purchase Saga

function* createSinglePurchaseSaga(action) {
  try {
    const response = yield call(createSinglePurchaseApiCall, action.payload);
    yield put(createSinglePurchaseSuccess(response));
  } catch (error) {
    yield put(createSinglePurchaseFailure(error));
  }
}

export function* watchCreateSinglePurchaseSaga() {
  yield takeEvery(CREATE_SINGLE_PURCHASE, createSinglePurchaseSaga);
}

// Update Single Purchase Saga

function* updateSinglePurchaseSaga(action) {
  try {
    const response = yield call(updateSinglePurchaseApiCall, action.payload);
    yield put(updateSinglePurchaseSuccess(response));
  } catch (error) {
    yield put(updateSinglePurchaseFailure(error));
  }
}

export function* watchUpdateSinglePurchaseSaga() {
  yield takeEvery(UPDATE_SINGLE_PURCHASE, updateSinglePurchaseSaga);
}

// Get Purchase Status List Saga

function* getPurchaseStatusListSaga() {
  try {
    const response = yield call(getPurchaseStatusListApiCall);
    yield put(getPurchaseStatusListSuccess(response));
  } catch (error) {
    yield put(getPurchaseStatusListFailure(error));
  }
}

export function* watchGetPurchaseStatusListSaga() {
  yield takeEvery(GET_PURCHASE_STATUS_LIST, getPurchaseStatusListSaga);
}

// Search Single Supplier Purchase List Saga

function* searchSingleSupplierPurchaseListSaga(action) {
  try {
    const response = yield call(
      searchSingleSupplierPurchaseListApiCall,
      action.payload
    );
    yield put(searchSingleSupplierPurchaseListSuccess(response));
  } catch (error) {
    yield put(searchSingleSupplierPurchaseListFailure(error));
  }
}

export function* watchSearchSingleSupplierPurchaseListSaga() {
  yield takeEvery(
    SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST,
    searchSingleSupplierPurchaseListSaga
  );
}

// Get Purchase Item Category List Saga

function* getPurchaseItemCategoryListSaga() {
  try {
    const response = yield call(getPurchaseItemCategoryListApiCall);
    yield put(getPurchaseItemCategoryListSuccess(response));
  } catch (error) {
    yield put(getPurchaseItemCategoryListFailure(error));
  }
}

export function* watchGetPurchaseItemCategoryListSaga() {
  yield takeEvery(
    GET_PURCHASE_ITEM_CATEGORY_LIST,
    getPurchaseItemCategoryListSaga
  );
}

// Search Purchase Item By Job Id Saga

function* searchPurchaseItemByJobIdSaga(action) {
  try {
    const response = yield call(
      searchPurchaseItemByJobIdApiCall,
      action.payload
    );
    yield put(searchPurchaseItemByJobIdSuccess(response));
  } catch (error) {
    yield put(searchPurchaseItemByJobIdFailure(error));
  }
}

export function* watchSearchPurchaseItemByJobIdSaga() {
  yield takeEvery(
    SEARCH_PURCHASE_ITEM_BY_JOB_ID,
    searchPurchaseItemByJobIdSaga
  );
}

// Convert Purchase Item To Billable Saga
function* convertPurchaseItemToBillableSaga(action) {
  try {
    const response = yield call(
      convertPurchaseItemToBillableApiCall,
      action.payload
    );
    yield put(convertPurchaseItemToBillableSuccess(response));
  } catch (error) {
    yield put(convertPurchaseItemToBillableFailure(error));
  }
}

export function* watchConvertPurchaseItemToBillableSaga() {
  yield takeEvery(
    CONVERT_PURCHASE_ITEM_TO_BILLABLE,
    convertPurchaseItemToBillableSaga
  );
}

// Unlink Purchase Item Billable Saga
function* unlinkPurchaseItemBillableSaga(action) {
  try {
    const response = yield call(
      unlinkPurchaseItemBillableApiCall,
      action.payload
    );
    yield put(unlinkPurchaseItemBillableSuccess(response));
  } catch (error) {
    yield put(unlinkPurchaseItemBillableFailure(error));
  }
}

export function* watchUnlinkPurchaseItemBillableSaga() {
  yield takeEvery(
    UNLINK_PURCHASE_ITEM_BILLABLE,
    unlinkPurchaseItemBillableSaga
  );
}

// Mark Purchase Item Billed Saga
function* markPurchaseItemBilledSaga(action) {
  try {
    const response = yield call(
      markPurchaseItemBilledApiCall,
      action.payload
    );
    yield put(markPurchaseItemBilledSuccess(response));
  } catch (error) {
    yield put(markPurchaseItemBilledFailure(error));
  }
}

export function* watchMarkPurchaseItemBilledSaga() {
  yield takeEvery(MARK_PURCHASE_ITEM_BILLED, markPurchaseItemBilledSaga);
}

// Mark Purchase Item Ignored Saga
function* markPurchaseItemIgnoredSaga(action) {
  try {
    const response = yield call(
      markPurchaseItemIgnoredApiCall,
      action.payload
    );
    yield put(markPurchaseItemIgnoredSuccess(response));
  } catch (error) {
    yield put(markPurchaseItemIgnoredFailure(error));
  }
}

export function* watchMarkPurchaseItemIgnoredSaga() {
  yield takeEvery(MARK_PURCHASE_ITEM_IGNORED, markPurchaseItemIgnoredSaga);
}

// Add New Purchase Status Saga
function* addNewPurchaseStatusSaga(action) {
  try {
    const response = yield call(addNewPurchaseStatusApiCall, action.payload);
    yield put(addNewPurchaseStatusSuccess(response));
  } catch (error) {
    yield put(addNewPurchaseStatusFailure(error));
  }
}

export function* watchAddNewPurchaseStatusSaga() {
  yield takeEvery(ADD_NEW_PURCHASE_STATUS, addNewPurchaseStatusSaga);
}

// Delete Purchase Status Saga
function* deletePurchaseStatusSaga(action) {
  try {
    const response = yield call(deletePurchaseStatusApiCall, action.payload);
    yield put(deletePurchaseStatusSuccess(response));
  } catch (error) {
    yield put(deletePurchaseStatusFailure(error));
  }
}

export function* watchDeletePurchaseStatusSaga() {
  yield takeEvery(DELETE_PURCHASE_STATUS, deletePurchaseStatusSaga);
}

// Update Purchase Status Saga
function* updatePurchaseStatusSaga(action) {
  try {
    const response = yield call(updatePurchaseStatusApiCall, action.payload);
    yield put(updatePurchaseStatusSuccess(response));
  } catch (error) {
    yield put(updatePurchaseStatusFailure(error));
  }
}

export function* watchUpdatePurchaseStatusSaga() {
  yield takeEvery(UPDATE_PURCHASE_STATUS, updatePurchaseStatusSaga);
}

// Add New Purchase Item Category Saga
function* addNewPurchaseItemCategorySaga(action) {
  try {
    const response = yield call(
      addNewPurchaseItemCategoryApiCall,
      action.payload
    );
    yield put(addNewPurchaseItemCategorySuccess(response));
  } catch (error) {
    yield put(addNewPurchaseItemCategoryFailure(error));
  }
}

export function* watchAddNewPurchaseItemCategorySaga() {
  yield takeEvery(
    ADD_NEW_PURCHASE_ITEM_CATEGORY,
    addNewPurchaseItemCategorySaga
  );
}

// Delete Purchase Item Category Saga
function* deletePurchaseItemCategorySaga(action) {
  try {
    const response = yield call(
      deletePurchaseItemCategoryApiCall,
      action.payload
    );
    yield put(deletePurchaseItemCategorySuccess(response));
  } catch (error) {
    yield put(deletePurchaseItemCategoryFailure(error));
  }
}

export function* watchDeletePurchaseItemCategorySaga() {
  yield takeEvery(
    DELETE_PURCHASE_ITEM_CATEGORY,
    deletePurchaseItemCategorySaga
  );
}

// Update Purchase Item Category Saga
function* updatePurchaseItemCategorySaga(action) {
  try {
    const response = yield call(
      updatePurchaseItemCategoryApiCall,
      action.payload
    );
    yield put(updatePurchaseItemCategorySuccess(response));
  } catch (error) {
    yield put(updatePurchaseItemCategoryFailure(error));
  }
}

export function* watchUpdatePurchaseItemCategorySaga() {
  yield takeEvery(
    UPDATE_PURCHASE_ITEM_CATEGORY,
    updatePurchaseItemCategorySaga
  );
}

// Delete Single Purchase Saga
function* deleteSinglePurchaseSaga(action) {
  try {
    const response = yield call(deleteSinglePurchaseApiCall, action.payload);
    yield put(deleteSinglePurchaseSuccess(response));
  } catch (error) {
    yield put(deleteSinglePurchaseFailure(error));
  }
}

export function* watchDeleteSinglePurchaseSaga() {
  yield takeEvery(DELETE_SINGLE_PURCHASE, deleteSinglePurchaseSaga);
}

// Search Purchase Item List Saga
function* searchPurchaseItemListSaga(action) {
  try {
    const response = yield call(searchPurchaseItemListApiCall, action.payload);
    yield put(searchPurchaseItemListSuccess(response));
  } catch (error) {
    yield put(searchPurchaseItemListFailure(error));
  }
}

export function* watchSearchPurchaseItemListSaga() {
  yield takeEvery(SEARCH_PURCHASE_ITEM_LIST, searchPurchaseItemListSaga);
}

// Upload Purchase Draft Saga
function* uploadPurchaseDraftSaga(action) {
  try {
    const response = yield call(uploadPurchaseDraftApiCall, action.payload);
    console.log("response", response);
    yield put(uploadPurchaseDraftSuccess(response));
  } catch (error) {
    yield put(uploadPurchaseDraftFailure(error));
  }
}

export function* watchUploadPurchaseDraftSaga() {
  yield takeEvery(UPLOAD_PURCHASE_DRAFT, uploadPurchaseDraftSaga);
}

// Create File Attachment Saga
function* createFileAttachmentSaga(action) {
  try {
    const response = yield call(createFileAttachmentApiCall, action.payload);
    yield put(createFileAttachmentSuccess(response));
  } catch (error) {
    yield put(createFileAttachmentFailure(error));
  }
}

export function* watchCreateFileAttachmentSaga() {
  yield takeEvery(CREATE_FILE_ATTACHMENT, createFileAttachmentSaga);
}

// Search Purchase Attachment Saga
function* searchPurchaseAttachmentSaga(action) {
  try {
    const response = yield call(
      searchPurchaseAttachmentApiCall,
      action.payload
    );
    yield put(searchPurchaseAttachmentSuccess(response));
  } catch (error) {
    yield put(searchPurchaseAttachmentFailure(error));
  }
}

export function* watchSearchPurchaseAttachmentSaga() {
  yield takeEvery(SEARCH_PURCHASE_ATTACHMENT, searchPurchaseAttachmentSaga);
}

// Delete Job Attachment Saga
function* deleteJobAttachmentSaga(action) {
  try {
    const response = yield call(deleteJobAttachmentApiCall, action.payload);
    yield put(deleteJobAttachmentSuccess(response));
  } catch (error) {
    yield put(deleteJobAttachmentFailure(error));
  }
}

export function* watchDeleteJobAttachmentSaga() {
  yield takeEvery(DELETE_JOB_ATTACHMENT, deleteJobAttachmentSaga);
}

// Predict Transaction Financial Saga
function* predictTransactionFinancialSaga(action) {
  try {
    const response = yield call(predictTransactionFinancialApiCall, action.payload);
    yield put(predictTransactionFinancialSuccess(response));
  } catch (error) {
    yield put(predictTransactionFinancialFailure(error));
  }
}

export function* watchPredictTransactionFinancialSaga() {
  yield takeEvery(PREDICT_TRANSACTION_FINANCIAL, predictTransactionFinancialSaga);
}


// Saga Main Function
export default function* Purchase() {
  yield all([
    watchGetPurchaseListSaga(),
    watchGetSinglePurchaseSaga(),
    watchCreateSinglePurchaseSaga(),
    watchUpdateSinglePurchaseSaga(),
    watchGetPurchaseStatusListSaga(),
    watchSearchSingleSupplierPurchaseListSaga(),
    watchGetPurchaseItemCategoryListSaga(),
    watchSearchPurchaseItemByJobIdSaga(),
    watchConvertPurchaseItemToBillableSaga(),
    watchUnlinkPurchaseItemBillableSaga(),
    watchMarkPurchaseItemBilledSaga(),
    watchMarkPurchaseItemIgnoredSaga(),
    watchAddNewPurchaseStatusSaga(),
    watchDeletePurchaseStatusSaga(),
    watchUpdatePurchaseStatusSaga(),
    watchAddNewPurchaseItemCategorySaga(),
    watchDeletePurchaseItemCategorySaga(),
    watchUpdatePurchaseItemCategorySaga(),
    watchDeleteSinglePurchaseSaga(),
    watchSearchPurchaseItemListSaga(),
    watchUploadPurchaseDraftSaga(),
    watchCreateFileAttachmentSaga(),
    watchSearchPurchaseAttachmentSaga(),
    watchDeleteJobAttachmentSaga(),
    watchPredictTransactionFinancialSaga(),
  ]);
}
